import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { DiscussionDetailCreateRequestDTO, DiscussionDetailDTO, DiscussionDetailUpdateRequestDTO, DiscussionDetailDeleteRequestDTO, DiscussionDetailReadByIdRequestDTO, DiscussionDetailReadByDiscussionIdRequestDTO, DiscussionDetailList, DiscussionDetailMarkAsReadRequestDTO } from "./discussion-detail.interface";
import { DiscussionDetail_Create, DiscussionDetail_Update, DiscussionDetail_ReadAll, DiscussionDetail_Delete, DiscussionDetail_ReadById, DiscussionDetail_ReadByDiscussionId, DiscussionDetail_MarkAsRead } from "src/app/GlobalVariable";

@Injectable({
    providedIn: 'root'
})

export class DiscussionDetailService {

    http = inject(HttpClient);


    DiscussionDetail_Create(data: DiscussionDetailCreateRequestDTO): Observable<DiscussionDetailDTO> {
        return this.http.post<DiscussionDetailDTO>(DiscussionDetail_Create, data);
    }


    DiscussionDetail_Update(data: DiscussionDetailUpdateRequestDTO): Observable<DiscussionDetailDTO> {
        return this.http.post<DiscussionDetailDTO>(DiscussionDetail_Update, data);
    }
    DiscussionDetail_ReadAll(): Observable<DiscussionDetailList> {
        return this.http.get<DiscussionDetailList>(DiscussionDetail_ReadAll)
    }

    DiscussionDetail_Delete(data: DiscussionDetailDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(DiscussionDetail_Delete, data);
    }


    DiscussionDetail_ReadById(data: DiscussionDetailReadByIdRequestDTO): Observable<DiscussionDetailDTO> {
        return this.http.post<DiscussionDetailDTO>(DiscussionDetail_ReadById, data);
    }


    DiscussionDetail_ReadByDiscussionId(data: DiscussionDetailReadByDiscussionIdRequestDTO): Observable<DiscussionDetailList> {
        return this.http.post<DiscussionDetailList>(DiscussionDetail_ReadByDiscussionId, data);
    }

    DiscussionDetail_MarkAsRead(data: DiscussionDetailMarkAsReadRequestDTO): Observable<void> {
        return this.http.post<void>(DiscussionDetail_MarkAsRead, data);
    }

}